import { Controller, MobileContextMenu } from '@tencent/workbench';
import { EditFeature } from './edit-feature';
import { MOBILE_CONTEXTMENU_ITEMS, config } from './config';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { RegionType } from '@src/slide/domain/selection/constant/region';
import { isIframeShapeModel, isUiModelIsAttachment } from '@src/slide/domain/ui-model/elements/element-judge';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { ISlideBaseAppServices } from '@src/slide/application/entry/toc/base/slide-base-app-services.interface';

/**
 * 移动端 - 编辑
 */
@Controller({
    mobileContextMenuItems: MOBILE_CONTEXTMENU_ITEMS,
})
export class EditController {
    constructor(private readonly feature: EditFeature) {}

    @MobileContextMenu(config.name, 'onClick')
    public setFocus() {
        this.feature.setFocus();
    }

    @MobileContextMenu(config.name, 'shouldHide')
    public shouldHide() {
        const model = this.feature.getSelectionService().selectedElements.getCurrentModel();
        if (isUiModelIsAttachment(model)) {
            // 附件类型不显示编辑
            return true;
        }
        const { lastMouseDownRegion } = this.feature.getSelectionService();
        if (
            lastMouseDownRegion === RegionType.EDITOR
            && (model.type === UIModelType.TABLE
            || model.type === UIModelType.SHAPE)
            && !this.getEditorInstanceService().checkEditorIsEditing()
            && !isIframeShapeModel(model)
        ) {
            return false;
        }
        return true;
    }

    private getEditorInstanceService() {
        return (AppServiceProvider.getInstance().getAppServices() as ISlideBaseAppServices)
            .viewableServiceLayer.editorInstanceService;
    }
}
